import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_EXAM_COUNTRY_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_EXAM_COUNTRY_URL} from '../../constants/apiUrls';
import {LookupListApiItem} from '../../api/user/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  isSpers?: boolean;
  onSuccess?: (data: LookupListApiItem[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetCountry = ({onSuccess, onError, enabled, isSpers}: Input = {}) => {
  const getCountry = async () => {
    const res = await axiosClient.get<LookupListApiItem[]>(GET_NON_NATIONAL_EXAM_COUNTRY_URL(isSpers || false));
    return res.data;
  };
  return useCustomQuery([GET_NON_NATIONAL_EXAM_COUNTRY_QUERY_KEY, isSpers], getCountry, {
    onSuccess,
    onError,
    enabled,
    staleTime: Infinity,
  });
};
